import type { DealListItem, DealStage } from '../api/deals.client.js';

export type DealViewMode = 'kanban' | 'list';
export type DealActivityFilter = 'all' | 'due' | 'missing';

export interface DealWorkbenchFilters {
  query: string;
  stage: DealStage | 'all';
  ownerId: string;
  activity: DealActivityFilter;
}

export const DEFAULT_DEAL_FILTERS: DealWorkbenchFilters = {
  activity: 'all',
  ownerId: 'all',
  query: '',
  stage: 'all',
};

function getContactName(deal: DealListItem): string {
  return [deal.contact?.firstName, deal.contact?.lastName].filter(Boolean).join(' ');
}

export function filterDealsForWorkbench(
  deals: readonly DealListItem[],
  filters: DealWorkbenchFilters,
): DealListItem[] {
  const query = filters.query.trim().toLowerCase();

  return deals.filter((deal) => {
    if (filters.stage !== 'all' && deal.stage !== filters.stage) {
      return false;
    }

    if (filters.ownerId !== 'all' && deal.ownerId !== filters.ownerId) {
      return false;
    }

    if (filters.activity === 'due' && deal.nextActivityDue === null) {
      return false;
    }

    if (filters.activity === 'missing' && deal.nextActivityDue !== null) {
      return false;
    }

    if (query.length === 0) {
      return true;
    }

    return `${deal.title} ${getContactName(deal)}`.toLowerCase().includes(query);
  });
}

export function getActiveFilterCount(filters: DealWorkbenchFilters): number {
  return [
    filters.query.trim(),
    filters.stage === 'all' ? '' : filters.stage,
    filters.ownerId === 'all' ? '' : filters.ownerId,
    filters.activity === 'all' ? '' : filters.activity,
  ].filter(Boolean).length;
}

export function toggleSelection(selected: ReadonlySet<string>, id: string): Set<string> {
  const next = new Set(selected);

  if (next.has(id)) {
    next.delete(id);
  } else {
    next.add(id);
  }

  return next;
}

export function clearSelection(_selected: ReadonlySet<string>): Set<string> {
  return new Set<string>();
}

export function getFailedSelection(selectedIds: readonly string[], failedIds: ReadonlySet<string>): Set<string> {
  return new Set(selectedIds.filter((id) => failedIds.has(id)));
}
